/* eslint-disable react/no-unknown-property */
import React from 'react'
import { SvgIcon, SvgIconProps } from '@material-ui/core'

export const BlockIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path fillRule='evenodd' clipRule='evenodd' d='M4 12C4 10.154 4.635 8.458 5.688 7.103L16.897 18.312C15.542 19.366 13.846 20 12 20C7.589 20 4 16.411 4 12ZM20 12C20 13.846 19.365 15.542 18.312 16.897L7.103 5.688C8.458 4.634 10.154 4 12 4C16.411 4 20 7.589 20 12ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z' fill='#E2612D' />
      <mask id='blockIcon' mask-type='alpha' maskUnits='userSpaceOnUse' x='2' y='2' width='20' height='20'>
        <path fillRule='evenodd' clipRule='evenodd' d='M4 12C4 10.154 4.635 8.458 5.688 7.103L16.897 18.312C15.542 19.366 13.846 20 12 20C7.589 20 4 16.411 4 12ZM20 12C20 13.846 19.365 15.542 18.312 16.897L7.103 5.688C8.458 4.634 10.154 4 12 4C16.411 4 20 7.589 20 12ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z' fill='white' />
      </mask>
      <g mask='url(#blockIcon)'>
        <rect width='24' height='24' fill={props.color || '#E2612D'} />
      </g>
    </SvgIcon>
  )
}
